import { ago, plural } from '../format';
import { useApp } from '../store';
import { btn, mono, panelCol, sectionTitle } from '../ui';

export function Alerts() {
  const app = useApp();

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gap: 14, alignItems: 'start' }}>
      <section style={{ ...panelCol, gap: 12 }}>
        <span style={sectionTitle}>Открытые инциденты</span>

        {app.alerts.map(a => (
          <div
            key={a.id}
            style={{
              display: 'flex',
              gap: 13,
              alignItems: 'flex-start',
              padding: 14,
              borderRadius: 'var(--rs)',
              background: 'var(--panel2)'
            }}
          >
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                marginTop: 6,
                flex: 'none',
                background: a.sev === 'bad' ? 'var(--bad)' : a.sev === 'warn' ? 'var(--warn)' : 'var(--ink4)'
              }}
            />
            <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 5 }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>{a.title}</span>
              <span style={{ ...mono, fontSize: 11, color: 'var(--ink3)' }}>{a.meta}</span>
              <span style={{ fontSize: 12.5, color: 'var(--ink2)' }}>{a.detail}</span>
              <div style={{ display: 'flex', gap: 9, marginTop: 5 }}>
                <button
                  className="hov"
                  onClick={() => {
                    app.selectIds(a.hostIds);
                    app.go('fleet');
                  }}
                  style={{
                    ...btn,
                    padding: '6px 12px',
                    borderRadius: 'var(--rs)',
                    border: '1px solid var(--line2)',
                    fontSize: 11.5,
                    color: 'var(--ink2)',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Выбрать хосты · {a.hostIds.length}
                </button>
                <button
                  className="hov"
                  onClick={() => void app.muteAlert(a.id)}
                  style={{
                    ...btn,
                    padding: '6px 12px',
                    borderRadius: 'var(--rs)',
                    fontSize: 11.5,
                    color: 'var(--ink3)'
                  }}
                >
                  Заглушить 2 ч
                </button>
              </div>
            </div>
            <span style={{ fontSize: 11, color: 'var(--ink3)', flex: 'none' }}>{ago(a.since)}</span>
          </div>
        ))}

        {!app.alerts.length && (
          <span style={{ fontSize: 12.5, color: 'var(--ink3)' }}>
            Открытых инцидентов нет — все пороги в норме.
          </span>
        )}
      </section>

      <section style={{ ...panelCol, gap: 12 }}>
        <span style={sectionTitle}>Пороги</span>

        {app.thresholds.map(t => (
          <div
            key={t.key}
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr auto auto',
              gap: 14,
              padding: '9px 0',
              borderBottom: '1px solid var(--line)',
              alignItems: 'baseline',
              fontSize: 12.5,
              opacity: t.enabled ? 1 : 0.45
            }}
          >
            <span>{t.label}</span>
            <span style={{ ...mono, fontSize: 12 }}>{t.value}</span>
            <span style={{ fontSize: 11, color: 'var(--ink3)' }}>{t.window}</span>
          </div>
        ))}

        <span style={{ fontSize: 11, color: 'var(--ink4)', lineHeight: 1.6 }}>
          Инциденты пересчитываются каждые 15 секунд по этим порогам. Всего под наблюдением{' '}
          {plural(app.hosts.length, ['хост', 'хоста', 'хостов'])}.
        </span>
      </section>
    </div>
  );
}
